import React, { useState, useEffect, useRef, useCallback } from 'react';

const LandingPage = ({ onSuccess }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [activeStep, setActiveStep] = useState(0);

  useEffect(() => {
    setTimeout(() => setIsVisible(true), 100);
  }, []);

  useEffect(() => {
    const cycle = setInterval(() => {
      setActiveStep(prev => (prev + 1) % 3);
    }, 3000);
    return () => clearInterval(cycle);
  }, []);

  const handleRegisterClick = (e) => {
    e.preventDefault();
    onSuccess();
  };

  const roles = [
    'Elektricien', 'HVAC Technicus', 'Lasser', 'Monteur', 'Mechanicien',
    'PLC-programmeur', 'Onderhoudstechnicus', 'CNC-operator', 'Procesoperator',
    'Loodgieter', 'Industrieel elektricien'
  ];

  const steps = [
    { num: '1', title: 'Vul je gegevens in', text: 'Functie, regio, wat je zoekt. Geen CV nodig.' },
    { num: '2', title: 'Wij zoeken matches', text: 'Jobs die bij jou passen komen automatisch.' },
    { num: '3', title: 'Jij kiest', text: 'Match? Praat direct met het bedrijf.' }
  ];

  return (
    <div className="tf" data-testid="landing-page">
      {/* Header */}
      <header className="tf-hdr">
        <div className="tf-logo">
          <img src="/assets/logo.png" alt="TalentFixr" className="tf-logo-img" />
          <span className="tf-logo-txt">TALENTFIXR.</span>
        </div>
        <NavPills active="schrijf" onSchrijf={handleRegisterClick} />
      </header>

      {/* Hero */}
      <section className="tf-hero">
        <div className={`tf-hero-inner ${isVisible ? 'vis' : ''}`}>
          <div className="tf-tag">Voor techniekers in België</div>
          <h1 className="tf-h1">
            <span className="tf-w tf-w1">SWIPE.</span>{' '}
            <span className="tf-w tf-w2">MATCH.</span>{' '}
            <span className="tf-w tf-w3">START.</span>
          </h1>
          <p className="tf-desc">
            Een nieuwe app waar jij als technieker direct gematcht wordt met jobs. 
            Geen CV, geen recruiters, geen gedoe.
          </p>
          <button onClick={handleRegisterClick} className="tf-cta" data-testid="register-button">
            Schrijf je gratis in
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
          </button>
          <p className="tf-micro">Duurt maar 2 minuten. Geen CV nodig.</p>
        </div>
      </section>

      {/* Hoe werkt het */}
      <section className="tf-expl">
        <h2 className="tf-expl-title">Hoe werkt het?</h2>
        <p className="tf-expl-sub">In 3 simpele stappen naar jouw volgende job</p>
        
        <div className="tf-steps">
          {steps.map((s, i) => (
            <div 
              key={i} 
              className={`tf-step ${activeStep === i ? 'tf-step-active' : ''}`}
              onClick={() => setActiveStep(i)}
            >
              <div className="tf-step-num">{s.num}</div>
              <div className="tf-step-content">
                <h3 className="tf-step-t">{s.title}</h3>
                <p className="tf-step-p">{s.text}</p>
              </div>
              <div className="tf-step-bar">
                <div className={`tf-step-fill ${activeStep === i ? 'tf-filling' : ''}`} />
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Waarom */}
      <section className="tf-why">
        <div className="tf-why-item">
          <div className="tf-why-icon">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#1A4D2E" strokeWidth="2" strokeLinecap="round"><path d="M22 11.08V12a10 10 0 11-5.93-9.14"/><path d="M22 4L12 14.01l-3-3"/></svg>
          </div>
          <h3 className="tf-why-t">Geen CV nodig</h3>
          <p className="tf-why-p">Gewoon invullen wat je doet en wat je zoekt. Klaar.</p>
        </div>
        <div className="tf-why-item">
          <div className="tf-why-icon">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#1A4D2E" strokeWidth="2" strokeLinecap="round"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/></svg>
          </div>
          <h3 className="tf-why-t">Geen recruiters</h3>
          <p className="tf-why-p">Niemand belt je op. Jij beslist wanneer en met wie je praat.</p>
        </div>
        <div className="tf-why-item">
          <div className="tf-why-icon">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#1A4D2E" strokeWidth="2" strokeLinecap="round"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>
          </div>
          <h3 className="tf-why-t">2 minuten</h3>
          <p className="tf-why-p">Meer heb je niet nodig om je profiel aan te maken.</p>
        </div>
      </section>

      {/* Bottom CTA */}
      <section className="tf-bot">
        <h2 className="tf-bot-t">Klaar om te starten?</h2>
        <p className="tf-bot-p">Schrijf je nu gratis in. Wij laten je weten als de app klaar is.</p>
        <button onClick={handleRegisterClick} className="tf-cta tf-cta-lg" data-testid="bottom-register-btn">
          Schrijf je gratis in
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
        </button>
      </section>

      {/* Marquee - bottom */}
      <div className="tf-mq-wrap">
        <div className="tf-mq">
          {[...roles, ...roles, ...roles].map((r, i) => (
            <span key={i} className="tf-mq-i"><span className="tf-mq-d" />{r}</span>
          ))}
        </div>
      </div>

      {/* Footer */}
      <footer className="tf-ft">
        <a href="/privacy">Privacybeleid</a>
        <a href="/terms">Algemene voorwaarden</a>
        <span>&copy; 2026 TALENTFIXR.</span>
      </footer>

      <style>{`
        .tf {
          min-height: 100vh; background: #F5EFE6; color: #1A4D2E;
          font-family: 'Inter', system-ui, -apple-system, sans-serif;
          overflow-x: hidden;
        }

        /* Header */
        .tf-hdr { display: flex; justify-content: space-between; align-items: center; padding: 20px 24px; gap: 12px; }
        .tf-logo { display: flex; align-items: center; gap: 10px; min-width: 0; }
        .tf-logo-img { width: 36px; height: 36px; object-fit: contain; flex-shrink: 0; }
        .tf-logo-txt { font-size: 20px; font-weight: 800; letter-spacing: 0.5px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
        .tf-hdr-btn {
          background: #1A4D2E; color: #F5EFE6; border: none;
          padding: 10px 24px; border-radius: 100px; font-size: 14px;
          font-weight: 600; cursor: pointer; transition: all 0.2s;
        }
        .tf-hdr-btn:hover { background: #143d24; transform: translateY(-1px); box-shadow: 0 4px 12px rgba(26,77,46,0.25); }

        /* Hero */
        .tf-hero {
          display: flex; justify-content: center; align-items: center;
          padding: 56px 24px 48px; max-width: 700px; margin: 0 auto;
        }
        .tf-hero-inner { text-align: center; }
        .tf-hero-inner {
          opacity: 0; transform: translateY(20px);
          transition: all 0.7s cubic-bezier(0.16,1,0.3,1);
        }
        .tf-hero-inner.vis { opacity: 1; transform: translateY(0); }

        .tf-tag {
          display: inline-block; background: rgba(26,77,46,0.08);
          padding: 8px 20px; border-radius: 100px; font-size: 14px;
          font-weight: 600; margin-bottom: 24px;
        }

        .tf-h1 { font-size: 44px; font-weight: 800; line-height: 1.05; margin-bottom: 20px; letter-spacing: -1.5px; }
        .tf-w {
          display: inline-block; opacity: 0; transform: translateY(14px);
          animation: wIn 0.5s cubic-bezier(0.16,1,0.3,1) forwards;
        }
        .tf-w1 { animation-delay: 0.15s; }
        .tf-w2 { animation-delay: 0.3s; }
        .tf-w3 { animation-delay: 0.45s; }
        @keyframes wIn { to { opacity: 1; transform: translateY(0); } }

        .tf-desc { font-size: 16px; line-height: 1.7; opacity: 0.65; margin-bottom: 32px; max-width: 480px; margin-left: auto; margin-right: auto; }

        .tf-cta {
          display: inline-flex; align-items: center; gap: 10px;
          background: #1A4D2E; color: #F5EFE6; border: none;
          padding: 16px 36px; border-radius: 100px; font-size: 16px;
          font-weight: 600; cursor: pointer;
          transition: all 0.25s cubic-bezier(0.16,1,0.3,1);
          box-shadow: 0 4px 16px rgba(26,77,46,0.2);
        }
        .tf-cta:hover { background: #143d24; transform: translateY(-2px); box-shadow: 0 8px 24px rgba(26,77,46,0.3); }
        .tf-cta:hover svg { transform: translateX(3px); }
        .tf-cta svg { transition: transform 0.25s ease; }
        .tf-cta-lg { padding: 18px 44px; font-size: 17px; }
        .tf-micro { font-size: 13px; opacity: 0.4; margin-top: 16px; }

        /* Explainer */
        .tf-expl {
          padding: 48px 24px 44px; max-width: 640px; margin: 0 auto; text-align: center;
          border-top: 1px solid rgba(26,77,46,0.08);
        }
        .tf-expl-title { font-size: 24px; font-weight: 800; margin-bottom: 6px; letter-spacing: -0.5px; }
        .tf-expl-sub { font-size: 15px; opacity: 0.5; margin-bottom: 32px; }

        .tf-steps { display: flex; flex-direction: column; gap: 12px; }
        .tf-step {
          background: #fff; border-radius: 14px; padding: 18px 20px;
          display: flex; align-items: flex-start; gap: 14px;
          cursor: pointer; transition: all 0.3s ease;
          border: 2px solid transparent; position: relative; overflow: hidden;
        }
        .tf-step-active { border-color: rgba(26,77,46,0.15); box-shadow: 0 4px 16px rgba(26,77,46,0.06); }
        .tf-step-num {
          flex-shrink: 0; width: 38px; height: 38px; border-radius: 50%;
          background: rgba(26,77,46,0.07); display: flex; align-items: center;
          justify-content: center; font-size: 15px; font-weight: 800;
          transition: all 0.3s ease;
        }
        .tf-step-active .tf-step-num { background: #1A4D2E; color: #F5EFE6; }
        .tf-step-content { flex: 1; text-align: left; }
        .tf-step-t { font-size: 16px; font-weight: 700; margin-bottom: 3px; }
        .tf-step-p { font-size: 14px; opacity: 0.55; line-height: 1.5; }
        .tf-step-bar { position: absolute; bottom: 0; left: 0; right: 0; height: 3px; background: rgba(26,77,46,0.05); }
        .tf-step-fill { height: 100%; width: 0; background: #1A4D2E; border-radius: 2px; }
        .tf-filling { animation: fillBar 3s linear forwards; }
        @keyframes fillBar { from { width: 0; } to { width: 100%; } }

        /* Why */
        .tf-why {
          display: flex; flex-direction: column; gap: 16px;
          padding: 12px 24px 48px; max-width: 640px; margin: 0 auto;
        }
        .tf-why-item {
          text-align: center; padding: 24px 20px;
          background: rgba(26,77,46,0.03); border-radius: 14px;
        }
        .tf-why-icon {
          display: inline-flex; align-items: center; justify-content: center;
          width: 50px; height: 50px; border-radius: 12px;
          background: rgba(26,77,46,0.07); margin-bottom: 12px;
        }
        .tf-why-t { font-size: 17px; font-weight: 700; margin-bottom: 4px; }
        .tf-why-p { font-size: 14px; opacity: 0.55; line-height: 1.5; }

        /* Bottom CTA */
        .tf-bot {
          text-align: center; padding: 48px 24px 56px;
          background: rgba(26,77,46,0.04); border-top: 1px solid rgba(26,77,46,0.06);
        }
        .tf-bot-t { font-size: 24px; font-weight: 800; margin-bottom: 8px; letter-spacing: -0.5px; }
        .tf-bot-p { font-size: 15px; opacity: 0.5; margin-bottom: 28px; }

        /* Marquee - at bottom */
        .tf-mq-wrap {
          overflow: hidden; padding: 14px 0;
          border-top: 1px solid rgba(26,77,46,0.06);
        }
        .tf-mq { display: flex; gap: 28px; white-space: nowrap; animation: mScroll 25s linear infinite; }
        .tf-mq-i { display: flex; align-items: center; gap: 10px; font-size: 13px; font-weight: 500; opacity: 0.35; flex-shrink: 0; }
        .tf-mq-d { width: 4px; height: 4px; border-radius: 50%; background: #1A4D2E; opacity: 0.4; }
        @keyframes mScroll { from { transform: translateX(0); } to { transform: translateX(-33.33%); } }

        /* Footer */
        .tf-ft {
          text-align: center; padding: 20px 24px; font-size: 12px; opacity: 0.4;
          display: flex; flex-wrap: wrap; justify-content: center; gap: 16px;
        }
        .tf-ft a { color: #1A4D2E; text-decoration: none; }
        .tf-ft a:hover { text-decoration: underline; }

        /* Tablet */
        @media (min-width: 768px) {
          .tf-hdr { padding: 24px 48px; }
          .tf-logo-img { width: 52px; height: 52px; }
          .tf-logo-txt { font-size: 28px; }
          .tf-nav-item { padding: 8px 20px; font-size: 14px; }
          .tf-hero { padding: 72px 48px 56px; }
          .tf-h1 { font-size: 64px; letter-spacing: -3px; }
          .tf-desc { font-size: 18px; }
          .tf-expl { padding: 56px 48px 48px; }
          .tf-expl-title { font-size: 28px; }
          .tf-why { flex-direction: row; gap: 16px; padding: 16px 48px 56px; }
          .tf-why-item { flex: 1; }
          .tf-bot-t { font-size: 28px; }
        }

        /* Desktop */
        @media (min-width: 1024px) {
          .tf-hdr { padding: 28px 64px; }
          .tf-logo-img { width: 56px; height: 56px; }
          .tf-logo-txt { font-size: 32px; }
          .tf-hero { padding: 88px 64px 64px; }
          .tf-h1 { font-size: 76px; letter-spacing: -4px; margin-bottom: 24px; }
          .tf-desc { font-size: 19px; margin-bottom: 36px; }
          .tf-expl { padding: 64px 64px 56px; max-width: 720px; }
          .tf-expl-title { font-size: 32px; }
          .tf-step { padding: 22px 24px; }
          .tf-step-t { font-size: 17px; }
          .tf-step-p { font-size: 15px; }
          .tf-why { padding: 20px 64px 64px; max-width: 720px; gap: 20px; }
          .tf-why-t { font-size: 18px; }
          .tf-why-p { font-size: 15px; }
          .tf-bot { padding: 64px 64px 72px; }
          .tf-bot-t { font-size: 32px; }
          .tf-bot-p { font-size: 16px; }
        }
      `}</style>
    </div>
  );
};

const NavPills = ({ active, onSchrijf }) => {
  const pillRef = useRef(null);
  const schrijfRef = useRef(null);
  const jobsRef = useRef(null);
  const [slider, setSlider] = useState({ left: 0, width: 0 });

  const measure = useCallback(() => {
    const container = pillRef.current;
    const target = active === 'schrijf' ? schrijfRef.current : jobsRef.current;
    if (!container || !target) return;
    const cRect = container.getBoundingClientRect();
    const tRect = target.getBoundingClientRect();
    setSlider({ left: tRect.left - cRect.left, width: tRect.width });
  }, [active]);

  useEffect(() => { measure(); window.addEventListener('resize', measure); return () => window.removeEventListener('resize', measure); }, [measure]);

  return (
    <nav ref={pillRef} style={{ display: 'flex', position: 'relative', background: 'rgba(26,77,46,0.08)', borderRadius: 100, padding: 3, flexShrink: 0 }}>
      <div style={{
        position: 'absolute', top: 3, height: 'calc(100% - 6px)',
        background: '#1A4D2E', borderRadius: 100, pointerEvents: 'none',
        transition: 'left 0.3s cubic-bezier(0.16,1,0.3,1), width 0.3s cubic-bezier(0.16,1,0.3,1)',
        left: slider.left, width: slider.width,
      }} />
      <button ref={schrijfRef} onClick={onSchrijf} style={{
        position: 'relative', zIndex: 1, padding: '7px 14px', border: 'none', background: 'none',
        fontSize: 12, fontWeight: 600, cursor: 'pointer', whiteSpace: 'nowrap',
        borderRadius: 100, color: active === 'schrijf' ? '#F5EFE6' : '#1A4D2E',
        fontFamily: 'inherit', transition: 'color 0.2s',
      }} data-testid="header-register-btn">Schrijf je in</button>
      <a ref={jobsRef} href="/jobs" style={{
        position: 'relative', zIndex: 1, padding: '7px 14px', border: 'none', background: 'none',
        fontSize: 12, fontWeight: 600, cursor: 'pointer', whiteSpace: 'nowrap',
        borderRadius: 100, textDecoration: 'none', textAlign: 'center',
        color: active === 'jobs' ? '#F5EFE6' : '#1A4D2E',
        fontFamily: 'inherit', transition: 'color 0.2s',
      }} data-testid="nav-jobs">JOBS</a>
    </nav>
  );
};

export default LandingPage;
